module.exports = __webpack_public_path__ + "img/login.a236d78a.svg";